import { API_URL } from "./apiBase";
import { Notification } from "../models/notification_model";

export async function getNotifications(
    accessToken: string
): Promise<Notification[]> {
    const response = await fetch(`${API_URL}/notifications/`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch notifications");
    }

    return response.json();
}

export async function updateNotification(
    accessToken: string,
    notificationId: string,
    updateData: Partial<Notification>
): Promise<Notification> {
    const response = await fetch(`${API_URL}/notifications/`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({notification_id:updateData._id}),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update notification");
    }

    return response.json();
}
